import { Link } from "react-router-dom";

export function Logo({ className = "", size = "md" }) {
  const dot = size === "sm" ? "h-2 w-2" : "h-2.5 w-2.5";
  const text = size === "sm" ? "text-lg" : "text-xl";
  return (
    <Link to="/" data-testid="brand-logo" className={`inline-flex items-center gap-2 ${className}`}>
      <span className="relative inline-flex items-center justify-center h-8 w-8 rounded-xl bg-[#E8FBF1]">
        <span className={`${dot} rounded-full bg-[#16A46B]`} />
        <span className="absolute -right-0.5 -bottom-0.5 h-3 w-3 rounded-full bg-[#1F5FD8] ring-2 ring-white" />
      </span>
      <span className={`font-display font-bold tracking-tight text-[#0B2B33] ${text}`}>SocialMind</span>
    </Link>
  );
}
